/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Update_SuccessInputs */

const en_admin_external_booking_edit_update_success = /** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking successfully updated. The visitor has been notified via email.`)
};

const de_admin_external_booking_edit_update_success = /** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung erfolgreich aktualisiert. Der Besucher wurde per E-Mail benachrichtigt.`)
};

const es_admin_external_booking_edit_update_success = /** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva actualizada correctamente. Se ha notificado al visitante por correo electrónico.`)
};

const fr_admin_external_booking_edit_update_success = /** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation mise à jour avec succès. Le visiteur a été notifié par e-mail.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */
const it_admin_external_booking_edit_update_success = en_admin_external_booking_edit_update_success;

/** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_update_success = en_admin_external_booking_edit_update_success;

/** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */
const pl_admin_external_booking_edit_update_success = en_admin_external_booking_edit_update_success;

/** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */
const hu_admin_external_booking_edit_update_success = en_admin_external_booking_edit_update_success;

/** @type {(inputs: Admin_External_Booking_Edit_Update_SuccessInputs) => LocalizedString} */
const ro_admin_external_booking_edit_update_success = en_admin_external_booking_edit_update_success;

/**
* | output |
* | --- |
* | "Booking successfully updated. The visitor has been notified via email." |
*
* @param {Admin_External_Booking_Edit_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_update_success = /** @type {((inputs?: Admin_External_Booking_Edit_Update_SuccessInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Update_SuccessInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_update_success(inputs)
	if (locale === "de") return de_admin_external_booking_edit_update_success(inputs)
	if (locale === "es") return es_admin_external_booking_edit_update_success(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_update_success(inputs)
	if (locale === "it") return it_admin_external_booking_edit_update_success(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_update_success(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_update_success(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_update_success(inputs)
	return ro_admin_external_booking_edit_update_success(inputs)
});
export { admin_external_booking_edit_update_success as "admin.external_booking_edit.update_success" }